/**
 * @module Worker
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */

// It is not considering import as declaration , throwing lint error at import statement itself

import { Injectable } from '@angular/core';
import { WorkerInput } from '@core/worker/core/worker-input';
import { WorkerOutput } from '@core/worker/core/worker-output';
import { WorkerMessenger } from '@core/worker/worker-messenger';
import { Observable } from 'rxjs';
import { WorkerUtils } from '../models/utils';
import WebpackWorker from 'worker-loader!./../worker.js';

@Injectable()
export class WorkerIpcService {
  private workerMessenger: WorkerMessenger;

  constructor() {
    if (!WorkerUtils.isIE()) {
      this.startWorker();
    }
  }

  public toWorker(input: WorkerInput): Observable<WorkerOutput> {
    return this.workerMessenger.postMessage(input);
  }

  public toWorkerPromise(input: WorkerInput): Promise<WorkerOutput> {
    return this.workerMessenger.postMessagePromise(input);
  }

  public terminate(): void {
    this.workerMessenger.terminate();
  }

  public restartWorker(): void {
    this.workerMessenger.terminate();
    this.startWorker();
  }

  public startWorker(): void {
    const worker = new WebpackWorker();
    this.workerMessenger = new WorkerMessenger(worker, this.cb);
  }
  /* tslint:disable:no-any */
  private cb = (event: any) => {
    // SPLIT THE MERGED STRING
    if (event.urlTime) {
      const messageResponse = event.urlTime.split(',');
      // CREATE NEW ADRUM AJAX OBJECT INSTANCE
      const str = 'ADRUM';
      if (window[str] && window[str].events) {
        const ajaxT = new window[str].events.Ajax();

        // SET URL
        ajaxT.url(messageResponse[0]);

        // SET TIMES - EXAMPLE ONLY USES ONE METRIC
        // FOR ALL METRICS, SEE -
        // ttps://docs.appdynamics.com/display/PRO45/Report+Events+with+the+
        // JavaScript+API#ReportEventswiththeJavaScriptAPI-ajax
        ajaxT.markSendTime(0);
        ajaxT.markFirstByteTime(0);
        ajaxT.markRespAvailTime(0);
        const radix = 10;
        ajaxT.markRespProcTime(parseInt(messageResponse[1], radix));

        // REPORT DATA (QUEUE FOR SENDING)
        window[str].report(ajaxT);
      }
    }
  };
}
